/**
 * 申請步驟內容入口
 */
/* eslint-disable no-console */
import React, { useContext } from 'react';
import { usePersistFn } from 'ahooks';
import type { FormModelsState } from 'umi';
import { MoPay } from '@gov-mo/components';
import { useSelector } from 'umi';
import { securityLevel, StepType } from '@/utils/ServiceConf';
import { PayOrderObject } from '@gov-mo/components/cjs/MoPay/type';
import StepContext from './StepContext';
import DataCheck from '../DataCheck';
import FormInfo from '../FormInfo';
import PaymentInformation from '../PaymentInformation';
import IdentityAuth from '../IdentityAuth';

const StepRender = (props) => {
  const context = useContext(StepContext);
  const { currentStep, handleNext } = props;

  // 從全局狀態中獲取數據（payData在點擊下一步的時候會存進去）
  const { payData } = useSelector((x: { formModels: FormModelsState }) => x.formModels);

  /**
   * 支付流程成功回调
   * ps:流程成功，不一定是支付成功，有可能会是支付失败
   */
  const handlePaySuccess = (e) => {
    console.log('支付成功', e);
    if (e?.data?.success && currentStep.StepType === StepType.payment) {
      handleNext();
    }
  };

  /**
   * 支付流程中断回调
   */
  const handlePayCancel = () => {
    console.log('支付被取消');
  };

  // 渲染對應步驟組件
  const renderStep = usePersistFn(() => {
    let res: React.ReactNode;
    switch (currentStep.stepType) {
      // 申請資料：表單
      case StepType.form:
        res = <FormInfo title={currentStep.stepName} />;
        break;
      // 資料確認：數據查看
      case StepType.dataCheck:
        res = <DataCheck />;
        break;
      // 身份識別
      case StepType.faceRecognition:
        res = (
          <IdentityAuth
            title={currentStep.stepName}
            authLevel={securityLevel.HIGH}
            onSuccess={() => {
              if (!context.isAuth) {
                // 身份识别成功，将身份识别结果存储起来
                context.isAuth = true;
                handleNext();
              }
            }}
            ref={(ref) => {
              context.identityRef = ref;
            }}
          />
        );
        break;
      // 支付
      case StepType.payment:
        if (payData) {
          // PC支付渠道选择页
          res = (
            <MoPay
              ref={(ref) => {
                context.moPayRef = ref;
              }}
              payOrder={payData as unknown as PayOrderObject}
              onPaySuccess={() => {
                if (!context.isPayed) {
                  context.isPayed = true;
                  handleNext();
                }
              }}
            />
          );
        } else {
          // PC和mobile支付账单页
          res = <PaymentInformation onSuccess={handlePaySuccess} onCancel={handlePayCancel} />;
        }
        break;
      default:
        res = null;
    }
    return res;
  });

  return <>{renderStep()}</>;
};

export default StepRender;
